import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const drawerWidth = 240;

const AdminLayout: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);  // Inicializado en `true` para que esté abierto por defecto

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Barra superior fija */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
            edge="start"
            sx={{ marginRight: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Admin Dashboard
          </Typography>
          <IconButton color="inherit">
            <AccountCircleIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Menú lateral */}
      <Drawer
        variant="persistent"
        open={drawerOpen}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <List>
          <ListItem component={Link} to="/admin">
            <ListItemText primary="Inicio Admin" />
          </ListItem>
          <ListItem component={Link} to="/admin/product-management">
            <ListItemText primary="Gestión de Productos" />
          </ListItem>
          <ListItem component={Link} to="/admin/product-carousel">
            <ListItemText primary="Carrousel de Productos" />
          </ListItem>
        </List>
      </Drawer>

      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: '80px 24px 24px', // Ajuste de padding para que no se solape con la AppBar
          marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Outlet /> {/* Aquí se renderiza el contenido de la página correspondiente */}
      </Box>
    </Box>
  );
};

export default AdminLayout;
